import Injection = EECore.Injection;
import AdsService from "../../services/ads/adsService";
import AdsEntity from "../../services/entities/ads/ads";
import Ads from "./ads";


@Injection.injectableClass("AdsList")
export default class AdsList implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("AdsList", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("AdsList", "AdsService")
  private adsService: AdsService;

  @Injection.injectableProperty("AdsList", EECore.Registrations.WEBCOMPONENT_FACTORY)
  private webComponentFactory: EECore.UI.WebComponentFactory;

  @Injection.injectableProperty("AdsList", EECore.Registrations.DOCUMENT)
  private document: Document;

  constructor(templateFactory: EECore.UI.TemplateFactory, adsService: AdsService, webComponentFactory: EECore.UI.WebComponentFactory, document: Document) {
    this.templateFactory = templateFactory;
    this.adsService = adsService;
    this.webComponentFactory = webComponentFactory;
    this.document = document;
  }

  load(container: Element): EECore.Promise<Element, string> {
    const contentPath = container.getAttribute("ee-content-path");

    return new EECore.Promise<Element, string>((resolve, reject) => {
      this.adsService.getList(contentPath).then((adsList: AdsEntity[]) => {
        if (adsList.length === 0) {
          resolve(this.document.createDocumentFragment() as any);
        } else {
          const template = this.renderTemplate();
          template.appendChild(this.renderAds(adsList));
          resolve(template);
        }
      }).catch(() => {
        reject("Could not get ads list information.");
      });
    });
  }

  private renderTemplate(): Element {
    return this.templateFactory.getTemplate("AdsList", null);
  }

  private renderAds(adsList: AdsEntity[]): Element {
    const documentFragment = this.document.createDocumentFragment() as any;
    for (let i = 0; i < adsList.length; i++) {
      const ads = this.webComponentFactory.getWebComponent(Ads) as Ads;
      ads.model = adsList[i];
      const e = ads.load();
      const trackedEl = this.adsService.trackAllLinks(e);
      documentFragment.appendChild(trackedEl);
    }
    return documentFragment;
  }
}